import { useTranslation } from 'react-i18next';

import { ReportFilter } from './ReportConfig.types';

const ReportFilters = (): ReportFilter => {
  const { t } = useTranslation();

  return {
    status: [
      {
        label: t('common.tableFilters.Expired'),
        value: 'Expired',
      },
      {
        label: t('common.tableFilters.FSBO'),
        value: 'FSBO',
      },
      {
        label: t('common.tableFilters.FRBO'),
        value: 'FRBO',
      },
      {
        label: t('common.tableFilters.Preforeclosure'),
        value: 'Preforeclosure',
      },
      {
        label: t('common.tableFilters.Neighborhood'),
        value: 'Neighborhood',
      },
      {
        label: t('common.tableFilters.Contact Plus'),
        value: 'Contact Plus',
      },
      {
        label: t('common.tableFilters.Other'),
        value: 'Other',
      },
    ],
    disposition: [
      {
        label: t('reports.Lead'),
        value: 'Lead',
      },
      {
        label: t('reports.Not Interested'),
        value: 'Not Interested',
      },
      {
        label: t('reports.Dead'),
        value: 'Dead',
      },
      {
        label: t('reports.Listed'),
        value: 'Listed',
      },
      {
        label: t('reports.Agent'),
        value: 'Agent',
      },
      {
        label: t('reports.Delete Listing'),
        value: 'Delete Listing',
      },
      {
        label: t('reports.Voicemail'),
        value: 'Voicemail',
      },
      {
        label: t('reports.Wrong Number'),
        value: 'Wrong Number',
      },
      {
        label: t('reports.Ring No Answer'),
        value: 'Ring No Answer',
      },
      {
        label: t('reports.Disconnected'),
        value: 'Disconnected',
      },
      {
        label: t('reports.Do Not Call'),
        value: 'Do Not Call',
      },
      {
        label: t('reports.Custom Dispositions'),
        value: 'Custom Dispositions',
      },
    ],
    callStatus: [
      {
        label: t('reports.Connected'),
        value: 'connected',
      },
      {
        label: t('reports.Machine Start'),
        value: 'machine-start',
      },
      {
        label: t('reports.User Hung-Up'),
        value: 'user-hung-up',
      },
      {
        label: t('reports.Failed'),
        value: 'failed',
      },
      {
        label: t('reports.Not Recognised'),
        value: 'not-recognised',
      },
      {
        label: t('reports.No Answer'),
        value: 'no-answer',
      },
      {
        label: t('reports.Busy'),
        value: 'busy',
      },
      {
        label: t('reports.Fax'),
        value: 'fax',
      },
    ],
  };
};

export default ReportFilters;
